module.exports = __webpack_public_path__ + "static/media/icon-write-warning.43edead9.svg";